var map, popup, Popup;
var flightPaths = [];
var markers = [];
var baseCoordinate = { lat: 38.8478562, lng: 34.9691324 };
var icons = {
        markerBlue : "/images/markerclusterer/circle-navy.png",
        markerOrange : "/images/markerclusterer/circle-orange.png"
 };

$(document).ready(function() {
	map = new google.maps.Map(document.getElementById('charter-search-map'), {
		center: baseCoordinate,
		zoom: 4,
		gestureHandling: "greedy",
		streetViewControl: false
	});

//	var infowindow = new google.maps.InfoWindow();
	
	
	$("#charter-dep-cities").change(function(){
		clearPaths();
		clearMarkers();
		var val = $("#charter-dep-cities").val();
		if(val != ''){
			fetchCharterData(val);
		}

	});
	
	
	function clearPaths(){
		flightPaths.map(function(item, index){
			item.setMap(null);
		})
		flightPaths = [];
	}
	
	function clearMarkers(){
		markers.map(function(item, index){
			item.setMap(null);
		})
		markers = [];
	}

	function generateLine(departure, arrival){

	    var flightPlanCoordinates = [
	        new google.maps.LatLng(departure.lat, departure.lng),
	        new google.maps.LatLng(arrival.lat, arrival.lng),
	    ];
		
	    var flightPath = new google.maps.Polyline({
	      path: flightPlanCoordinates,
	      strokeColor: "#ffb600",
	      strokeOpacity: .65,
		  geodesic: true,
	    });
		flightPath.setMap(map);
		
		flightPaths.push(flightPath);
	}
	
	function generateMarker(flight, icon, hasPopup){

		var cord = new google.maps.LatLng(flight.lat, flight.lng)

		var marker = new google.maps.Marker({
			icon: icon,
			position: cord,
			map: map,
		});
		
		marker.setPosition(cord);

        if(hasPopup) {
            var infowindow = new google.maps.InfoWindow();
            infowindow.setContent(generateInfoWindowContent(flight));
            infowindow.open(map, marker);
        }

		if(hasPopup){
			google.maps.event.addListener(infowindow, 'domready', function() {

			   // Reference to the DIV which receives the contents of the infowindow using jQuery
			   var iwOuter = $('.gm-style-iw');

			   var iwBackground = iwOuter.prev();
			   
			   iwOuter.next().remove();

			   // Remove the arrow shadow DIV
			   iwBackground.children(':nth-child(1)').css({'display' : 'none'});
			   // Remove the background shadow DIV
			   iwBackground.children(':nth-child(2)').css({'display' : 'none'});
			   // Remove the arrow DIV
			   iwBackground.children(':nth-child(3)').css({'display' : 'none'});
			   // Remove the white background DIV
			   iwBackground.children(':nth-child(4)').css({'display' : 'none'});

			});
			
		}

		markers.push(marker);
	}
	
	function fetchCharterData(selDepAirport){
		 $.ajax({
		        type : 'GET',
		        url : '/charterInfo/map',
		        data : {
		        	selDepAirport : selDepAirport,
		        },
		        dataType : 'json'
		    })
		    .done(function(response){
		    	if(response.arrivalAirports != undefined && response.departureAirport != undefined){
					var depAirport = response.departureAirport;
					var arrAirports = response.arrivalAirports;		
					generateMarker(depAirport, icons.markerOrange, false);
					
					arrAirports.map(function(item){
//						generateLine(depAirport, item);
						generateMarker(item, icons.markerBlue, true);
					});
					
					map.setCenter(new google.maps.LatLng(depAirport.lat, depAirport.lng))
		    	}
		    });
	}
	
	function generateInfoWindowContent(flight){
		var date = $.datepicker.formatDate("dd.mm.yy", new Date(flight.departureTime));
		var cityAirport = flight.cityName;
		var text = '<div id="charter-product-content">'+
	    	'<div class="charter-product-item">'+
	    		'<h4 class="charter-product-title">' + cityAirport + '</h4>'+
	    		'<p class="charter-product-price"><strong>'+ parseFloat(flight.price).toFixed(0) + " "+ flight.currency +'</strong></p>'+
	    	'</div>'+
    	'</div>';
		return text;
		
	}
});